module.exports = __webpack_public_path__ + "static/clothes-7cdbba715d678cd0d786d2fbf4ca8060.mp4";